import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=bea515f8&scoped=true&"
import script from "./Deal.vue?vue&type=script&lang=js&"
export * from "./Deal.vue?vue&type=script&lang=js&"
import style0 from "./Deal.vue?vue&type=style&index=0&id=bea515f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea515f8",
  null
  
)

export default component.exports